import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    PlanSelectionUpdateInput,
    UpdatePlanSelection as UpdatePlanSelectionMutation,
    UpdatePlanSelectionVariables as UpdatePlanSelectionMutationVariables,
} from 'nutshell-graphql-types';

import UPDATE_PLAN_SELECTION from '../mutations/update-plan-selection.graphql';
import GET_ACCOUNT_BILLING from '../queries/get-account-billing.graphql';

export function useUpdatePlanSelection(): {
    updatePlanSelection: (arg1: PlanSelectionUpdateInput) => Promise<any>;
    isUpdating: boolean;
    errorMessage: string | null | undefined;
} {
    const [updatePlanSelection, {loading, error}] = useMutation<
        UpdatePlanSelectionMutation,
        UpdatePlanSelectionMutationVariables
    >(UPDATE_PLAN_SELECTION);

    return {
        updatePlanSelection: (input: PlanSelectionUpdateInput) =>
            updatePlanSelection({
                variables: {input},
                update: (proxy, mutationResults) => {
                    const cacheResult = proxy.readQuery({
                        query: GET_ACCOUNT_BILLING,
                    });

                    if (cacheResult) {
                        const updatedPlan =
                            mutationResults &&
                            mutationResults.data &&
                            mutationResults.data.planSelectionUpdate;

                        if (!updatedPlan) return;

                        proxy.writeQuery({
                            query: GET_ACCOUNT_BILLING,
                            data: updatedPlan,
                        });
                    }
                },
            }),
        isUpdating: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
}
